import { getUserInfo } from "@/api/user";

export default {
  state: {
    //  {
    //       "id":48,
    //       "code":"d95ff5e1-52a2-5d56-be3b-4e6cc4deb2eb",
    //       "name":"星原统计垃圾分类项目组",
    //       "enterprise_name":"星原统计垃圾分类项目组",
    //       "mp_origin_id":null,
    //       "mp_name":null,
    //       "url":"https://jinxin-public.oss-cn-hangzhou.aliyuncs.com/proprietor/headPortrait/default.png",
    //       "type":"pa",
    //       "expired_at":null,
    //       "deleted_at":null,
    //       "owner_id":1656,
    //       "created_at":"2023-10-07 15:31:15",
    //       "updated_at":"2023-10-07 15:31:15",
    //       "user":{
    //           "id":1364,
    //           "userable_id":48,
    //           "userable_type":"App\Models\Users\Business\Proprietor",
    //           "type":"phone",
    //           "role": "admin",
    //           "username":"15381515231",
    //           "created_at":"2023-10-07 15:31:15",
    //           "updated_at":"2023-10-07 15:31:15",
    //           "userable":{
    //               "id":48,
    //               "code":"d95ff5e1-52a2-5d56-be3b-4e6cc4deb2eb",
    //               "name":"星原统计垃圾分类项目组",
    //               "enterprise_name":"星原统计垃圾分类项目组",
    //               "mp_origin_id":null,
    //               "mp_name":null,
    //               "url":"https://jinxin-public.oss-cn-hangzhou.aliyuncs.com/proprietor/headPortrait/default.png",
    //               "type":"pa",
    //               "expired_at":null,
    //               "deleted_at":null,
    //               "owner_id":1656,
    //               "created_at":"2023-10-07 15:31:15",
    //               "updated_at":"2023-10-07 15:31:15"
    //           }
    //       },
    //       "owner":{
    //           "id":1656,
    //           "userable_id":48,
    //           "userable_type":"App\Models\Users\Business\Proprietor",
    //           "type":"phone",
    //           "username":"18858737106",
    //           "created_at":"2023-12-27 00:06:00",
    //           "updated_at":"2023-12-27 00:06:00"
    //       }
    //   }
    proprietor: null
  },
  mutations: {
    SET_PROPRIETOR(state, data) {
      state.proprietor = data;
    }
  },
  actions: {
    async getProprietor({ commit }) {
      await getUserInfo().then(res => {
        if (res.data) {
          commit("SET_PROPRIETOR", res.data);
        }
      });
    }
  },
  getters: {
    isOwner: state => {
      return state.proprietor && state.proprietor.user
        ? state.proprietor.owner_id === state.proprietor.user.id
        : false;
    },
    role: state => {
      return state.proprietor && state.proprietor.user
        ? state.proprietor.user.role
        : null;
    },
  }
};
